/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.84"
        height="95.22"
        viewBox="0 0 79.84 95.22"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="m39.92 2.91.17.15c10.16 8.66 22.19 13.15 37 13.85h.27v17.96c-.27 13-2 22.64-6.06 31.34l-.24.51C65.43 78.3 55.58 86.94 40.25 92.56l-.26.09.42.15C24.47 87.11 14.35 78.22 8.68 66.21l-.24-.53c-3.21-7-4.88-14.63-5.53-24.12l-.09-1.43c-.1-1.7-.16-3.45-.2-5.26V16.92h.27c14.78-.7 26.81-5.19 37-13.85ZM39.08.32C28.84 9.43 16.6 14.02 1.22 14.48A1.25 1.25 0 0 0 0 15.72v15.15a137 137 0 0 0 .84 16.31l.17 1.32a62.93 62.93 0 0 0 5.33 18.76c6 12.63 16.59 22 33.16 27.89a1.21 1.21 0 0 0 .84 0c16.57-5.91 27.21-15.26 33.16-27.89 3.87-8.19 5.66-17.12 6.18-28.55l.06-1.51q0-1.14.06-2.31v-19.2a1.25 1.25 0 0 0-1.21-1.24c-15.39-.46-27.62-5-37.87-14.16a1.28 1.28 0 0 0-1.68 0Z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M49.61 34.07a12.2 12.2 0 0 0-7.92 3l-1.43 1.28-1.43-1.28a12.53 12.53 0 0 0-16.48.16 9.69 9.69 0 0 0 .36 14.57l17.16 15.39a.6.6 0 0 0 .78 0l17.17-15.38a9.7 9.7 0 0 0 .35-14.57 12.27 12.27 0 0 0-8.35-3.17Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithHeartIcon';

export default Icon;
